import { CREATE_PAYMENT_FAILURE, CREATE_PAYMENT_REQUEST, CREATE_PAYMENT_SUCCESS } from "./ActionType";

const initialState = {
  payment: null,
  loading: false,
  error: "",
};

export const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case CREATE_PAYMENT_REQUEST:
      return { ...state, loading: true };

    case CREATE_PAYMENT_SUCCESS:
      return { ...state, payment: action.payload , loading: false, error: ""};

    case CREATE_PAYMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};